export default "__VITE_ASSET__DvI4TgvH__"